import './bootstrap';
import './plugins';
import Vue from 'vue';
//import CKEditor from 'ckeditor4-vue';
import './core/coreApp';
import store from './store/Index'
import './common/Translator'
import './common/Helper/helpers'
import './common/commonComponent'
import './tenant/TenantComponent-CP'
import './tenant/TenantComponent-CPB'
import { QuillEditor } from 'vue-quill-editor';

// Import Quill editor
import VueQuillEditor from 'vue-quill-editor'

// Import Quill styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// Register as a Vue plugin
Vue.use(VueQuillEditor)

const app = new Vue({
    store,
    strict: true,
    el: '#app',
});
